import type { ArticleContent } from "./types";

export const articleFr: Record<string, ArticleContent> = {
  "basetao-spreadsheet-guide": {
    slug: "basetao-spreadsheet-guide",
    image:
      "https://readdy.ai/api/search-image?query=A%20clean%20workspace%20flat%20lay%20with%20a%20laptop%20showing%20a%20colorful%20spreadsheet%20grid%2C%20a%20notebook%2C%20a%20coffee%20cup%20and%20a%20folded%20sage%20green%20sweater%20on%20a%20warm%20cream%20desk%2C%20soft%20natural%20light%2C%20airy%20editorial%20photography%2C%20fresh%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=art-guide&orientation=landscape&nocache=true",
    title: "Basetao Spreadsheet : guide complet produits, vendeurs et achats (2026)",
    cardDescription: "Comment fonctionne le tableur Basetao, comment les catégories sont organisées et comment trouver des vendeurs fiables avant d'acheter.",
    metaDescription: "Découvrez comment fonctionne le tableur Basetao, parcourez les catégories, trouvez des vendeurs fiables et comprenez la livraison et le contrôle qualité.",
    eyebrow: "Guide d'achat",
    intro: "Le Basetao Spreadsheet est un annuaire partagé qui rassemble liens produits, détails vendeurs et notes d'achat au même endroit. Ce guide explique son organisation, sa lecture et son utilisation pour acheter en toute confiance.",
    sections: [
      {
        heading: "Qu'est-ce que le Basetao Spreadsheet ?",
        paragraphs: [
          "Le Basetao Spreadsheet est une liste organisée de produits et de vendeurs, utilisée par les personnes qui achètent sur des marketplaces internationales. Au lieu de naviguer sans fin, on ouvre le tableur pour trouver des liens directs, des raccourcis de catégories et des notes vendeurs dans une seule vue.",
          "Il sert de pont entre une recherche de produit et un achat réel. Chaque entrée pointe généralement vers une page produit en ligne sur le site principal, afin que le tableur reste concentré sur l'objectif de vous faire trouver rapidement ce que vous cherchez.",
        ],
      },
      {
        heading: "Comment les catégories sont organisées",
        paragraphs: [
          "Le tableur regroupe les produits en catégories claires : Chaussures, Hoodies et Sweats, T-Shirts, Vestes, Pantalons et Shorts, Couvre-chefs, Ensembles, Sous-vêtements, Maillots, Accessoires, Sacs, Ceintures et Parfums.",
          "Chaque catégorie renvoie à une vue filtrée sur le site principal, pour passer d'une idée générale à une liste de produits précise en un seul clic.",
        ],
      },
      {
        heading: "Trouver des vendeurs fiables",
        paragraphs: [
          "Recherchez des vendeurs avec des fiches complètes, des notes de taille claires et des photos réalistes. Les entrées fiables incluent généralement un lien vers la page produit, une note sur la taille ou la matière, et une date de mise à jour.",
          "Si une fiche paraît vague ou sans détail complémentaire, restez prudent. Les entrées les plus utiles sont celles qui vous aident à vérifier un produit avant de vous engager.",
        ],
      },
      {
        heading: "Bases de la livraison et du contrôle qualité",
        paragraphs: [
          "Avant d'acheter, consultez le guide des tailles, la description des matières et les éventuels avis. Pour les vêtements, comparez les mesures indiquées aux vôtres plutôt que de vous fier aux tailles standard.",
          "Les délais et coûts de livraison varient selon l'article et la destination. Confirmez toujours le prix final, la fenêtre de livraison estimée et la politique de retour avant de finaliser une commande.",
        ],
      },
    ],
    comparisonTitle: "Référence rapide des catégories",
    comparisonHeaders: ["Catégorie", "À vérifier", "Idéal pour"],
    comparisonRows: [
      ["Chaussures", "Taille, semelle, couleurs", "Tous les jours & streetwear"],
      ["Hoodies / Sweats", "Matière, poids, coupe", "Looks décontractés & superposés"],
      ["T-Shirts", "Tissu, qualité d'impression, coupe", "Basiques & tees graphiques"],
      ["Vestes", "Isolation, imperméabilité, taille", "Vêtements d'extérieur & saisons"],
      ["Accessoires & Sacs", "Matière, bandoulière, capacité", "Touches finales"],
    ],
    faqTitle: "Questions fréquentes",
    faqs: [
      { q: "Le Basetao Spreadsheet est-il gratuit ?", a: "Oui. Le tableur est un annuaire informatif et les pages produits liées sont disponibles sur le site principal." },
      { q: "Faut-il un compte pour l'utiliser ?", a: "Non. La navigation dans les catégories et la lecture des guides ne nécessitent pas de compte. Les achats sont gérés sur le site principal." },
      { q: "À quelle fréquence le tableur est-il mis à jour ?", a: "Les entrées sont révisées régulièrement, mais la disponibilité et les prix peuvent changer. Vérifiez toujours sur la page produit en ligne." },
      { q: "Ce site est-il affilié aux vendeurs ?", a: "C'est une ressource d'information indépendante. Il organise des liens produits et vendeurs publics sans remplacer les politiques du site principal." },
    ],
    lastUpdated: "2026-08-19",
    author: "Équipe éditoriale Basetao Spreadsheet",
  },

  "basetao-review": {
    slug: "basetao-review",
    image:
      "https://readdy.ai/api/search-image?query=A%20modern%20desk%20scene%20with%20a%20tablet%20displaying%20a%20product%20listing%20and%20a%20small%20star%20rating%20graphic%20printed%20on%20paper%20beside%20a%20coffee%20cup%2C%20warm%20terracotta%20accents%2C%20soft%20natural%20light%2C%20editorial%20photography%2C%20fresh%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=art-review&orientation=landscape",
    title: "Avis Basetao : expédition, entrepôt, QC et sécurité",
    cardDescription: "Un regard honnête sur l'expédition, l'entrepôt, le contrôle qualité et la sécurité de Basetao — ce qui fonctionne et ce qu'il faut surveiller.",
    metaDescription: "Un avis honnête sur Basetao couvrant les options d'expédition, la gestion de l'entrepôt, le contrôle qualité et la sécurité de l'acheteur.",
    eyebrow: "Avis",
    intro: "Cet avis passe en revue les aspects de Basetao qui comptent le plus — expédition, entrepôt, contrôle qualité et sécurité — pour vous aider à décider s'il correspond à votre façon d'acheter.",
    sections: [
      {
        heading: "Expédition : options et à quoi s'attendre",
        paragraphs: [
          "Basetao propose une gamme de méthodes d'expédition qui varient selon la destination, la rapidité et le coût. Les services express coûtent plus cher mais offrent un suivi détaillé, tandis que les options économiques sont moins chères et plus lentes.",
          "Le meilleur choix dépend de la rapidité dont vous avez besoin et de votre budget. Vérifiez toujours la fenêtre de livraison estimée avant de finaliser une commande.",
        ],
      },
      {
        heading: "Entrepôt et traitement des commandes",
        paragraphs: [
          "L'entrepôt est l'étape où vos articles sont reçus, vérifiés et préparés pour l'expédition. Un entrepôt bien géré garde votre commande ensemble et confirme que ce que vous avez acheté correspond à ce qui est envoyé.",
          "Des mises à jour claires réduisent les surprises. Si un article arrive endommagé ou différent de la fiche, les notes et photos de l'entrepôt servent de base à une demande de remboursement ou d'échange.",
        ],
      },
      {
        heading: "Contrôle qualité et sécurité",
        paragraphs: [
          "Le contrôle qualité aide à repérer les problèmes évidents avant l'expédition, mais ce n'est pas une garantie de perfection. Les photos et listes de contrôle sont utiles, mais de petits défauts peuvent passer.",
          "Pour la sécurité, achetez via des méthodes de paiement reconnues, conservez vos relevés de commande et vérifiez les détails du vendeur avant tout achat important.",
        ],
      },
    ],
    comparisonTitle: "Basetao en un coup d'œil",
    comparisonHeaders: ["Aspect", "Points forts", "À surveiller"],
    comparisonRows: [
      ["Expédition", "Plusieurs méthodes et suivi", "Coût et délai selon la méthode"],
      ["Entrepôt", "Consolidation et contrôles", "Dépend de l'état à l'arrivée"],
      ["Contrôle qualité", "Photos et listes de contrôle", "Pas une garantie de perfection"],
      ["Sécurité", "Méthodes de paiement reconnues", "Vérifiez toujours les vendeurs"],
    ],
    faqTitle: "Questions fréquentes",
    faqs: [
      { q: "Basetao est-il un service fiable ?", a: "De nombreux acheteurs l'utilisent avec succès, mais comme toute marketplace, tout dépend des vendeurs et articles choisis. Se renseigner sur chaque produit réduit le risque." },
      { q: "Basetao inspecte-t-il chaque article ?", a: "Les contrôles d'entrepôt et le contrôle qualité aident à repérer les problèmes, mais ne garantissent pas que chaque article soit parfait." },
      { q: "Puis-je suivre ma commande Basetao ?", a: "La plupart des méthodes incluent un suivi. Choisissez un service suivi pour suivre votre colis de l'entrepôt à votre porte." },
    ],
    lastUpdated: "2026-08-19",
    author: "Équipe éditoriale Basetao Spreadsheet",
  },

  "is-basetao-legit": {
    slug: "is-basetao-legit",
    image:
      "https://readdy.ai/api/search-image?query=A%20magnifying%20glass%20resting%20over%20a%20printed%20document%20on%20a%20clean%20desk%20with%20a%20small%20padlock%20and%20a%20pen%2C%20soft%20peach%20background%2C%20natural%20light%2C%20editorial%20photography%2C%20fresh%20airy%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=art-legit&orientation=landscape",
    title: "Basetao est-il légitime ? Sécurité, QC et guide d'achat",
    cardDescription: "Une réponse claire sur la légitimité de Basetao, avec les étapes de sécurité et de contrôle qualité qui protègent votre argent.",
    metaDescription: "Basetao est-il légitime ? Nous détaillons sécurité, contrôle qualité et protection de l'acheteur pour acheter en confiance.",
    eyebrow: "Vérification sécurité",
    intro: "Une question fréquente des nouveaux acheteurs est de savoir si Basetao est légitime. La réponse courte est que c'est un vrai service utilisé par beaucoup, mais votre sécurité dépend de la façon dont vous achetez.",
    sections: [
      {
        heading: "Ce qui rend un service légitime",
        paragraphs: [
          "Un service légitime a des politiques claires, un vrai support client et des options de paiement et d'expédition transparentes. Basetao les propose, mais la qualité des vendeurs et des fiches varie toujours.",
          "La légitimité de la plateforme ne rend pas automatiquement chaque produit ou vendeur digne de confiance. Traitez chaque achat comme une décision distincte.",
        ],
      },
      {
        heading: "Comment protéger votre argent",
        paragraphs: [
          "Utilisez des méthodes de paiement reconnues offrant une protection de l'acheteur, et conservez un relevé de chaque commande, message et reçu. Évitez de payer hors plateforme ou par des méthodes intraçables.",
          "Si une offre semble trop belle pour être vraie, c'est souvent le cas. Comparez les prix entre les fiches et lisez attentivement la description avant de payer.",
        ],
      },
      {
        heading: "Le rôle du contrôle qualité",
        paragraphs: [
          "Le contrôle qualité est une couche utile qui vérifie les articles pour les problèmes évidents avant l'expédition. Il réduit — sans éliminer — le risque de recevoir un produit erroné ou endommagé.",
          "Demandez des photos QC quand elles sont disponibles, et signalez tout écart dès la réception pour maximiser vos chances de résolution.",
        ],
      },
    ],
    comparisonTitle: "Liste de vérification de légitimité",
    comparisonHeaders: ["Contrôle", "Pourquoi", "Que faire"],
    comparisonRows: [
      ["Méthode de paiement", "Protection de l'acheteur", "Utiliser des options reconnues"],
      ["Détails du vendeur", "Confiance et responsabilité", "Lire fiches et avis"],
      ["Photos QC", "Repère les problèmes visibles", "Les demander si possible"],
      ["Relevés de commande", "Support en cas de litige", "Conserver reçus et messages"],
    ],
    faqTitle: "Questions fréquentes",
    faqs: [
      { q: "Basetao est-il une arnaque ?", a: "Non. Basetao est une plateforme légitime, mais vous devez toujours vous renseigner sur les vendeurs et produits avant d'acheter." },
      { q: "Que faire si ma commande n'arrive jamais ?", a: "Contactez le support avec les détails et le suivi de votre commande. Les méthodes de paiement reconnues offrent souvent une protection supplémentaire." },
      { q: "Dois-je demander des photos QC ?", a: "Oui. Elles vous aident à repérer les problèmes évidents avant l'expédition et vous donnent une preuve si quelque chose ne va pas." },
    ],
    lastUpdated: "2026-08-19",
    author: "Équipe éditoriale Basetao Spreadsheet",
  },

  "basetao-shipping-cost": {
    slug: "basetao-shipping-cost",
    image:
      "https://readdy.ai/api/search-image?query=A%20stack%20of%20cardboard%20shipping%20boxes%20with%20a%20shipping%20label%20and%20a%20measuring%20tape%20on%20a%20warm%20sand%20table%2C%20soft%20natural%20light%2C%20minimal%20editorial%20photography%2C%20fresh%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=art-shipping-cost&orientation=landscape",
    title: "Coût d'expédition Basetao : guide complet et comparaison",
    cardDescription: "Comment les frais d'expédition Basetao sont calculés, les méthodes disponibles et comment choisir l'option fiable la moins chère.",
    metaDescription: "Un guide complet des frais d'expédition Basetao — comment les prix sont calculés, les méthodes disponibles et comment choisir la moins chère.",
    eyebrow: "Expédition",
    intro: "Le coût d'expédition est l'une des premières choses que les acheteurs veulent comprendre. Les prix de Basetao dépendent de la taille et du poids de l'article, de la destination et de la méthode choisie.",
    sections: [
      {
        heading: "Comment les frais d'expédition sont calculés",
        paragraphs: [
          "La plupart des prix d'expédition reposent sur le poids réel ou volumétrique du colis et la distance parcourue. Les articles plus grands et plus lourds coûtent naturellement plus cher à expédier.",
          "Le coût final est généralement affiché avant le paiement, mais vérifiez si les taxes ou frais de manutention sont inclus pour éviter les surprises.",
        ],
      },
      {
        heading: "Comparer les méthodes d'expédition",
        paragraphs: [
          "Les méthodes économiques sont les moins chères mais les plus lentes, tandis que les services express sont plus rapides et plus chers. Entre les deux, les services standard équilibrent coût et délai.",
          "Choisir la bonne méthode est un compromis entre budget et rapidité. Si vous n'êtes pas pressé, l'expédition économique peut faire économiser une somme appréciable.",
        ],
      },
      {
        heading: "Comment réduire les coûts",
        paragraphs: [
          "Consolider plusieurs articles en un seul envoi réduit souvent le coût par article. Attendre d'avoir une commande plus importante peut rendre l'économie plus intéressante.",
          "Comparez le coût total — prix de l'article plus expédition — plutôt que les frais d'expédition seuls. Un article légèrement plus cher avec une expédition moins chère peut rester la meilleure affaire.",
        ],
      },
    ],
    comparisonTitle: "Comparaison des méthodes d'expédition",
    comparisonHeaders: ["Méthode", "Coût", "Rapidité", "Idéal pour"],
    comparisonRows: [
      ["Économique", "Le plus bas", "Le plus lent", "Petits budgets, sans urgence"],
      ["Standard", "Modéré", "Équilibré", "La plupart des commandes"],
      ["Express", "Le plus élevé", "Le plus rapide", "Articles urgents ou de valeur"],
      ["Consolidé", "Moins cher par article", "Variable", "Plusieurs articles à la fois"],
    ],
    faqTitle: "Questions fréquentes",
    faqs: [
      { q: "Pourquoi les frais d'expédition varient-ils autant ?", a: "Le coût dépend du poids et de la taille du colis, du pays de destination et de la méthode choisie." },
      { q: "Est-il moins cher d'expédier plusieurs articles ensemble ?", a: "Généralement oui. Consolider les articles en un seul colis réduit souvent le coût par article." },
      { q: "Les taxes sont-elles incluses dans le prix d'expédition ?", a: "Cela varie. Vérifiez toujours le détail du prix final pour voir si les taxes ou frais sont inclus." },
    ],
    lastUpdated: "2026-08-19",
    author: "Équipe éditoriale Basetao Spreadsheet",
  },

  "basetao-shipping-guide": {
    slug: "basetao-shipping-guide",
    image:
      "https://readdy.ai/api/search-image?query=A%20small%20cardboard%20parcel%20with%20a%20shipping%20label%20next%20to%20a%20delivery%20van%20model%20and%20a%20clipboard%20on%20a%20soft%20olive%20green%20background%2C%20natural%20light%2C%20editorial%20photography%2C%20fresh%20airy%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=art-shipping-guide&orientation=landscape",
    title: "Guide d'expédition Basetao : méthodes, délais et suivi",
    cardDescription: "Un guide pratique des méthodes d'expédition, des délais de livraison et du suivi Basetao pour savoir exactement à quoi vous attendre.",
    metaDescription: "Comprenez les méthodes d'expédition, les délais de livraison et le suivi Basetao. Apprenez à choisir le bon service et à suivre votre colis.",
    eyebrow: "Guide d'expédition",
    intro: "Comprendre l'expédition avant de commander élimine l'essentiel du stress de l'attente. Ce guide couvre les principales méthodes, les délais typiques et le suivi de votre colis.",
    sections: [
      {
        heading: "Les méthodes d'expédition expliquées",
        paragraphs: [
          "Basetao expédie via un mélange de services économiques, standard et express. Chacun équilibre coût, rapidité et niveau de suivi.",
          "Votre choix doit refléter l'urgence de la commande et vos économies souhaitées. Pour la plupart des acheteurs, un service standard suivi est un bon compromis.",
        ],
      },
      {
        heading: "Délais de livraison par méthode",
        paragraphs: [
          "Les délais dépendent de la méthode et de la destination. L'expédition économique peut prendre des semaines, tandis que l'express peut arriver en quelques jours.",
          "Traitez les estimations comme un guide et non une promesse. Douanes, jours fériés et météo peuvent ajouter du temps à un calendrier prévisible.",
        ],
      },
      {
        heading: "Comment fonctionne le suivi",
        paragraphs: [
          "Un numéro de suivi vous permet de suivre votre colis de l'entrepôt à votre porte. La plupart des services mettent à jour le statut aux points clés du trajet.",
          "Si le suivi ne se met plus à jour, attendez quelques jours avant de contacter le support, car les scans internationaux accusent parfois du retard.",
        ],
      },
    ],
    comparisonTitle: "Aperçu de la livraison",
    comparisonHeaders: ["Méthode", "Délai typique", "Suivi", "Bon à savoir"],
    comparisonRows: [
      ["Économique", "2–6 semaines", "Limité", "Option la moins chère"],
      ["Standard", "1–3 semaines", "Bon", "Choix équilibré"],
      ["Express", "3–7 jours", "Détaillé", "Le plus rapide et cher"],
      ["Messagerie", "Variable", "Porte à porte", "Souvent le plus fiable"],
    ],
    faqTitle: "Questions fréquentes",
    faqs: [
      { q: "Combien de temps prend l'expédition Basetao ?", a: "Cela dépend de la méthode et de la destination, de quelques jours en express à plusieurs semaines en économique." },
      { q: "Vais-je recevoir un numéro de suivi ?", a: "La plupart des méthodes standard et express incluent un suivi. Les options économiques peuvent offrir un suivi limité." },
      { q: "Que faire si mon colis est en retard ?", a: "Vérifiez d'abord le statut du suivi, puis contactez le support si aucune mise à jour n'a lieu depuis longtemps." },
    ],
    lastUpdated: "2026-08-19",
    author: "Équipe éditoriale Basetao Spreadsheet",
  },

  "basetao-coupon-discount-code": {
    slug: "basetao-coupon-discount-code",
    image:
      "https://readdy.ai/api/search-image?query=A%20pair%20of%20scissors%20and%20a%20discount%20gift%20tag%20with%20a%20receipt%20and%20a%20small%20stack%20of%20coins%20on%20a%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20minimal%20editorial%20photography%2C%20fresh%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=art-coupon&orientation=landscape",
    title: "Coupon et code promo Basetao : guide à jour",
    cardDescription: "Où trouver les coupons et codes promo Basetao, comment les utiliser et comment éviter les offres expirées ou invalides.",
    metaDescription: "Trouvez et utilisez les coupons et codes promo Basetao. Apprenez d'où ils viennent, comment les appliquer et éviter les offres expirées.",
    eyebrow: "Économies",
    intro: "Les coupons et codes promo sont un moyen simple de réduire le coût total d'une commande. Ce guide explique d'où ils viennent, comment les utiliser et éviter les pièges courants.",
    sections: [
      {
        heading: "D'où viennent les coupons et codes",
        paragraphs: [
          "Les codes promo sont souvent partagés via les newsletters, les promotions saisonnières et le site principal. Certains s'appliquent à tout le site, d'autres à des catégories ou montants minimums spécifiques.",
          "Les codes les plus fiables viennent de sources officielles. Les codes trouvés sur des sites tiers doivent être vérifiés, car ils peuvent être obsolètes ou invalides.",
        ],
      },
      {
        heading: "Comment appliquer un code promo",
        paragraphs: [
          "La plupart des codes se saisissent au paiement dans un champ dédié avant de confirmer. La remise est ensuite déduite de votre total avant paiement.",
          "Lisez d'abord les conditions, car beaucoup de codes exigent un montant minimum ou excluent certaines catégories. Une mauvaise application peut faire paraître un code expiré alors qu'il ne l'est pas.",
        ],
      },
      {
        heading: "Éviter les offres expirées ou invalides",
        paragraphs: [
          "Vérifiez toujours la date d'expiration et le montant minimum avant de construire votre panier autour d'un code. Un code expiré la semaine dernière ne fonctionnera pas cette semaine.",
          "Si un code ne s'applique pas, revérifiez l'orthographe et les conditions plutôt que de conclure que l'offre est fausse. Certaines remises sont sensibles à la casse ou réservées aux nouveaux clients.",
        ],
      },
    ],
    comparisonTitle: "Types de remise en un coup d'œil",
    comparisonHeaders: ["Type", "Fonctionnement", "Exigence typique", "Où le trouver"],
    comparisonRows: [
      ["Pourcentage", "Réduit le total d'un pourcentage", "Souvent un minimum", "Newsletters & promotions"],
      ["Montant fixe", "Déduit une somme du total", "Valeur minimale", "Campagnes saisonnières"],
      ["Livraison offerte", "Supprime les frais de port", "Peut exiger un minimum", "Bannières du site"],
      ["Offre catégorie", "S'applique à une catégorie", "Spécifique à la catégorie", "Pages produits & promos"],
    ],
    faqTitle: "Questions fréquentes",
    faqs: [
      { q: "Où trouver un code promo Basetao ?", a: "Consultez le site principal, les newsletters et les promotions saisonnières. Les sources officielles sont les plus fiables." },
      { q: "Pourquoi mon code promo ne fonctionne pas ?", a: "Il peut être expiré, exiger un minimum ou être limité à certaines catégories ou aux nouveaux clients." },
      { q: "Puis-je combiner plusieurs coupons ?", a: "Généralement non. La plupart des boutiques n'acceptent qu'un code par commande, choisissez celui qui vous fait le plus économiser." },
    ],
    lastUpdated: "2026-08-19",
    author: "Équipe éditoriale Basetao Spreadsheet",
  },

  "basetao-warehouse-guide": {
    slug: "basetao-warehouse-guide",
    image:
      "https://readdy.ai/api/search-image?query=A%20clean%20bright%20warehouse%20aisle%20with%20neatly%20stacked%20cardboard%20boxes%20on%20steel%20shelves%20and%20a%20soft%20stone%20color%20palette%2C%20natural%20overhead%20light%2C%20minimal%20editorial%20photography%2C%20fresh%20airy%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=art-warehouse&orientation=landscape",
    title: "Guide de l'entrepôt Basetao : comment fonctionne le stockage",
    cardDescription: "Comment l'entrepôt Basetao reçoit, stocke et consolide vos articles avant leur expédition.",
    metaDescription: "Découvrez comment l'entrepôt Basetao reçoit, stocke et consolide vos articles, et son impact sur les délais et l'exactitude des commandes.",
    eyebrow: "Entrepôt",
    intro: "L'entrepôt est l'endroit où vos articles sont reçus, stockés et préparés pour l'expédition. Comprendre cette étape aide à mieux décider de la consolidation et de la livraison.",
    sections: [
      {
        heading: "Comment l'entrepôt reçoit les articles",
        paragraphs: [
          "Quand un vendeur expédie un article, il arrive à l'entrepôt et est enregistré dans votre commande. Cette étape confirme que le bon article a été reçu avant son stockage.",
          "Les relevés de réception sont utiles car ils créent une trace écrite. Si quelque chose manque ou est incorrect, le journal de l'entrepôt est souvent le premier endroit à vérifier.",
        ],
      },
      {
        heading: "Stockage et consolidation",
        paragraphs: [
          "Les articles sont stockés jusqu'à ce que vous soyez prêt à les expédier. Si vous achetez chez plusieurs vendeurs, l'entrepôt peut tout consolider en un seul colis, ce qui réduit souvent les frais.",
          "La consolidation est précieuse pour les commandes internationales, où expédier plusieurs petits colis séparément coûterait bien plus cher qu'une seule boîte.",
        ],
      },
      {
        heading: "Préparer votre commande pour l'expédition",
        paragraphs: [
          "Avant l'expédition, le personnel confirme le contenu et prépare le colis. Les photos et listes de contrôle à cette étape aident à repérer les problèmes évidents tôt.",
          "Un colis bien préparé a moins de chances d'arriver endommagé. Renseignez-vous sur l'emballage et les photos disponibles si vous expédiez des articles fragiles ou de valeur.",
        ],
      },
    ],
    comparisonTitle: "Flux de l'entrepôt",
    comparisonHeaders: ["Étape", "Ce qui se passe", "Pourquoi c'est important"],
    comparisonRows: [
      ["Réception", "Articles enregistrés dans la commande", "Confirme le bon article"],
      ["Stockage", "Articles conservés jusqu'à l'envoi", "Permet d'attendre et combiner"],
      ["Consolidation", "Plusieurs articles réunis", "Réduit le coût par article"],
      ["Emballage", "Contenu vérifié et emballé", "Réduit dommages et erreurs"],
    ],
    faqTitle: "Questions fréquentes",
    faqs: [
      { q: "Combien de temps les articles restent-ils à l'entrepôt ?", a: "Les fenêtres de stockage varient, consultez la politique actuelle pour éviter des frais ou retours automatiques." },
      { q: "Qu'est-ce que la consolidation ?", a: "La consolidation réunit des articles de plusieurs vendeurs en un seul colis, ce qui réduit généralement le coût total d'expédition." },
      { q: "L'entrepôt inspecte-t-il mes articles ?", a: "Des contrôles de base sont courants, mais le contrôle qualité détaillé est souvent une étape distincte que vous pouvez demander." },
    ],
    lastUpdated: "2026-08-19",
    author: "Équipe éditoriale Basetao Spreadsheet",
  },

  "basetao-qc-guide": {
    slug: "basetao-qc-guide",
    image:
      "https://readdy.ai/api/search-image?query=Two%20hands%20inspecting%20a%20folded%20garment%20with%20a%20checklist%20clipboard%20and%20a%20measuring%20tape%20on%20a%20clean%20desk%2C%20soft%20sage%20green%20background%2C%20natural%20light%2C%20editorial%20photography%2C%20fresh%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=art-qc&orientation=landscape",
    title: "Guide QC Basetao : le contrôle qualité expliqué",
    cardDescription: "Ce que le contrôle qualité Basetao vérifie vraiment, comment demander des photos QC et ce que le processus peut ou non garantir.",
    metaDescription: "Comprenez le contrôle qualité Basetao — ce qu'il vérifie, comment demander des photos QC et ce qu'il peut ou non garantir.",
    eyebrow: "Contrôle qualité",
    intro: "Le contrôle qualité, ou QC, est l'étape où vos articles sont inspectés pour les problèmes évidents avant l'expédition. C'est l'un des outils les plus utiles pour acheter en confiance.",
    sections: [
      {
        heading: "Ce que le contrôle qualité vérifie",
        paragraphs: [
          "Le QC vérifie généralement que l'article correspond à la fiche, paraît correct et ne présente pas de dommage évident. Pour les vêtements, cela peut inclure la taille, la couleur et les coutures de base.",
          "L'objectif est de repérer les problèmes clairs avant qu'un article ne traverse le monde. Ce n'est pas un test approfondi, mais cela filtre de nombreux problèmes courants.",
        ],
      },
      {
        heading: "Comment demander des photos QC",
        paragraphs: [
          "De nombreux services permettent de demander des photos de vos articles avant l'expédition. Elles vous montrent exactement ce que vous recevez et confirment la correspondance avec la fiche.",
          "Examinez soigneusement les photos. Si quelque chose semble anormal — mauvaise couleur, défaut visible ou style différent — il est bien plus facile de corriger avant l'expédition.",
        ],
      },
      {
        heading: "Ce que le QC peut et ne peut pas faire",
        paragraphs: [
          "Le QC repère les problèmes visibles, mais ne peut pas tester la durabilité, le toucher du tissu ou la qualité à long terme. De petits défauts cachés peuvent passer un contrôle visuel.",
          "Utilisez le QC comme une partie de votre décision, pas une garantie complète. Combinez-le avec une lecture attentive des fiches et un choix de vendeur fiable.",
        ],
      },
    ],
    comparisonTitle: "Aperçu du processus QC",
    comparisonHeaders: ["Étape", "Ce qu'il vérifie", "Limite"],
    comparisonRows: [
      ["Correspondance", "Article vs. fiche", "Ne vérifie pas les détails cachés"],
      ["Inspection visuelle", "Dommages ou défauts évidents", "Petits défauts possibles"],
      ["Taille / couleur", "Spécifications de base", "La coupe dépend de vous"],
      ["Photos", "Ce que vous recevrez", "Pas un test de durabilité"],
    ],
    faqTitle: "Questions fréquentes",
    faqs: [
      { q: "Le contrôle qualité vaut-il la peine ?", a: "Oui, surtout pour les vêtements et articles de valeur. Il repère de nombreux problèmes évidents avant l'expédition." },
      { q: "Le QC garantit-il un article parfait ?", a: "Non. Le QC repère les problèmes visibles mais ne peut pas tester la durabilité, le toucher ou la qualité à long terme." },
      { q: "Comment obtenir des photos QC ?", a: "Demandez-les via le service lors de la commande, si l'option est disponible." },
    ],
    lastUpdated: "2026-08-19",
    author: "Équipe éditoriale Basetao Spreadsheet",
  },

  "basetao-safety-guide": {
    slug: "basetao-safety-guide",
    image:
      "https://readdy.ai/api/search-image?query=A%20small%20padlock%20and%20a%20shield-shaped%20wooden%20token%20on%20a%20clean%20desk%20with%20a%20notebook%20and%20pen%2C%20soft%20warm%20gray%20background%2C%20natural%20light%2C%20editorial%20photography%2C%20fresh%20airy%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=art-safety&orientation=landscape",
    title: "Guide de sécurité et prévention des arnaques Basetao",
    cardDescription: "Des étapes pratiques pour rester en sécurité sur Basetao — paiements sécurisés, repérer les vendeurs suspects et protéger votre compte.",
    metaDescription: "Restez en sécurité sur Basetao avec des conseils anti-arnaque : paiements sécurisés, repérage des vendeurs suspects et protection de votre compte.",
    eyebrow: "Sécurité",
    intro: "Acheter en sécurité est surtout une question de bonnes habitudes. Ce guide couvre les paiements sécurisés, le repérage des vendeurs suspects et la protection de votre compte et de votre argent.",
    sections: [
      {
        heading: "Utiliser des méthodes de paiement sécurisées",
        paragraphs: [
          "Payez toujours via des méthodes reconnues et traçables offrant une protection de l'acheteur. Évitez de payer directement les vendeurs ou via des services de transfert intraçables.",
          "Si quelqu'un vous demande de payer hors plateforme ou par une méthode inhabituelle, considérez-le comme un signal d'alarme et passez votre chemin.",
        ],
      },
      {
        heading: "Repérer les vendeurs suspects",
        paragraphs: [
          "Les vendeurs suspects ont souvent des fiches vagues, des prix irréalistes ou vous pressent d'agir vite. Un prix très en dessous de la moyenne est rarement une vraie affaire.",
          "Vérifiez les détails du vendeur, lisez la description complète et cherchez des informations cohérentes. Les vendeurs fiables fournissent des fiches claires et précises.",
        ],
      },
      {
        heading: "Protéger votre compte",
        paragraphs: [
          "Utilisez un mot de passe fort et unique et activez les fonctions de sécurité disponibles. Ne partagez jamais vos identifiants ni vos codes à usage unique, même avec quelqu'un se présentant comme le support.",
          "Conservez les relevés de commandes, messages et paiements. Une bonne documentation facilite la résolution d'un litige en cas de problème.",
        ],
      },
    ],
    comparisonTitle: "Liste de vérification sécurité",
    comparisonHeaders: ["Habitude", "Pourquoi", "Signal d'alarme à éviter"],
    comparisonRows: [
      ["Paiements reconnus", "Protection de l'acheteur", "Transferts directs ou intraçables"],
      ["Vérifier le vendeur", "Responsabilité", "Fiches vagues ou absentes"],
      ["Lire les descriptions", "Éviter les surprises", "Prix irréalistes"],
      ["Conserver les relevés", "Litiges plus faciles", "Supprimer l'historique tôt"],
    ],
    faqTitle: "Questions fréquentes",
    faqs: [
      { q: "Quel est le moyen le plus sûr de payer sur Basetao ?", a: "Utilisez des méthodes de paiement reconnues et traçables avec protection de l'acheteur. Évitez les transferts directs." },
      { q: "Comment repérer un vendeur suspect ?", a: "Cherchez les fiches vagues, les prix irréalistes et la pression à agir vite. Les vendeurs fiables donnent des détails clairs." },
      { q: "Que faire si je soupçonne une arnaque ?", a: "Arrêtez la transaction, signalez le vendeur via la plateforme et contactez le support avec vos relevés." },
    ],
    lastUpdated: "2026-08-19",
    author: "Équipe éditoriale Basetao Spreadsheet",
  },

  "basetao-buying-guide": {
    slug: "basetao-buying-guide",
    image:
      "https://readdy.ai/api/search-image?query=A%20paper%20shopping%20bag%20with%20a%20folded%20sweater%20and%20a%20pair%20of%20shoes%20beside%20a%20tablet%20on%20a%20warm%20blush%20pink%20background%2C%20soft%20natural%20light%2C%20editorial%20photography%2C%20fresh%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=art-buying&orientation=landscape",
    title: "Guide d'achat Basetao : de la navigation au paiement",
    cardDescription: "Un guide d'achat Basetao étape par étape — du choix d'une catégorie à l'examen des photos QC et au paiement sécurisé.",
    metaDescription: "Un guide d'achat Basetao étape par étape couvrant la navigation, le choix du vendeur, le contrôle qualité et le paiement sécurisé.",
    eyebrow: "Guide d'achat",
    intro: "Acheter via Basetao est simple une fois qu'on connaît le processus. Ce guide vous accompagne de votre première recherche jusqu'à un paiement confiant et sécurisé.",
    sections: [
      {
        heading: "Commencez par la bonne catégorie",
        paragraphs: [
          "Parcourez d'abord par catégorie — Chaussures, Hoodies, T-Shirts, Vestes, Sacs et plus — pour transformer une idée large en liste de produits ciblée. Chaque catégorie ouvre une vue filtrée sur le site principal.",
          "Affiner tôt fait gagner du temps. Plus vous êtes clair sur ce que vous voulez, plus il est facile de comparer les options qui correspondent vraiment.",
        ],
      },
      {
        heading: "Choisir un vendeur et lire la fiche",
        paragraphs: [
          "Lisez la description complète, vérifiez les notes de taille et regardez les photos. Une bonne fiche précise la matière, les dimensions et le contenu.",
          "Comparez quelques vendeurs plutôt que de sauter sur le premier résultat. De petites différences de prix ou de détail peuvent changer ce que vous recevez.",
        ],
      },
      {
        heading: "Finaliser avec QC et paiement sécurisé",
        paragraphs: [
          "Demandez des photos QC si l'option est disponible et examinez-les avant l'expédition. Puis finalisez le paiement via une méthode reconnue et traçable.",
          "Vérifiez la méthode d'expédition, la fenêtre de livraison estimée et le coût total avant de confirmer. Quelques secondes de plus évitent la plupart des problèmes.",
        ],
      },
    ],
    comparisonTitle: "Processus d'achat en un coup d'œil",
    comparisonHeaders: ["Étape", "Ce que vous faites", "Conseil clé"],
    comparisonRows: [
      ["Naviguer", "Choisir une catégorie", "Partir d'une idée claire"],
      ["Sélectionner", "Comparer les vendeurs", "Lire la description complète"],
      ["Examiner", "Vérifier tailles & photos", "Demander le QC si possible"],
      ["Payer", "Payer en sécurité", "Confirmer total et expédition"],
    ],
    faqTitle: "Questions fréquentes",
    faqs: [
      { q: "Comment commencer à acheter sur Basetao ?", a: "Choisissez une catégorie, parcourez la liste filtrée sur le site principal et comparez quelques options." },
      { q: "Dois-je demander le contrôle qualité ?", a: "Oui, surtout pour les vêtements ou articles de valeur. Cela aide à repérer les problèmes évidents avant l'expédition." },
      { q: "Que vérifier avant de payer ?", a: "Confirmez les détails de l'article, la méthode d'expédition, le délai estimé et le coût total avant de finaliser." },
    ],
    lastUpdated: "2026-08-19",
    author: "Équipe éditoriale Basetao Spreadsheet",
  },

  "basetao-seller-guide": {
    slug: "basetao-seller-guide",
    image:
      "https://readdy.ai/api/search-image?query=A%20minimal%20storefront%20concept%20with%20a%20small%20wooden%20sign%2C%20a%20handshake%20figurine%20and%20product%20cards%20on%20a%20warm%20khaki%20background%2C%20soft%20natural%20light%2C%20editorial%20photography%2C%20fresh%20airy%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=art-seller&orientation=landscape",
    title: "Guide des vendeurs Basetao : trouver des vendeurs fiables",
    cardDescription: "Comment identifier les vendeurs Basetao fiables, lire les fiches avec un œil critique et comparer avant de vous engager.",
    metaDescription: "Apprenez à trouver des vendeurs Basetao fiables, à lire les fiches de façon critique et à comparer vos options avant d'acheter.",
    eyebrow: "Vendeurs",
    intro: "Le vendeur que vous choisissez a un grand impact sur ce que vous recevez. Ce guide explique comment identifier les vendeurs fiables et lire les fiches avec un œil critique.",
    sections: [
      {
        heading: "Ce qui rend un vendeur fiable",
        paragraphs: [
          "Les vendeurs fiables fournissent des fiches complètes avec des photos claires, des tailles précises et des descriptions de matière honnêtes. Ils répondent aux questions et proposent des prix réalistes.",
          "La cohérence est un signal fort. Un vendeur dont les fiches sont détaillées et exactes sur plusieurs produits est souvent plus sûr qu'un vendeur aux descriptions vagues.",
        ],
      },
      {
        heading: "Lire une fiche de façon critique",
        paragraphs: [
          "Regardez au-delà de la première photo et lisez chaque détail. Vérifiez le guide des tailles, la matière et la cohérence entre photos et description.",
          "Méfiez-vous des fiches qui n'utilisent que des photos de stock, omettent les mesures ou évitent de répondre aux questions de base. L'absence de détail est souvent un signe.",
        ],
      },
      {
        heading: "Comparer les vendeurs avant de s'engager",
        paragraphs: [
          "Comparez quelques vendeurs pour le même type d'article. Regardez le prix, le délai, la qualité de la fiche et les avis ou notes disponibles.",
          "L'option la moins chère n'est pas toujours la meilleure. Un prix légèrement supérieur chez un vendeur plus détaillé et réactif peut vous éviter une déception.",
        ],
      },
    ],
    comparisonTitle: "Liste d'évaluation des vendeurs",
    comparisonHeaders: ["Facteur", "Signal fiable", "Signal d'alarme"],
    comparisonRows: [
      ["Détail de la fiche", "Photos et tailles claires", "Description vague"],
      ["Prix", "Réaliste et cohérent", "Suspectement bas"],
      ["Communication", "Répond aux questions", "Évite ou ignore"],
      ["Photos", "Correspondent à la description", "Photos de stock uniquement"],
    ],
    faqTitle: "Questions fréquentes",
    faqs: [
      { q: "Comment trouver un vendeur Basetao fiable ?", a: "Cherchez des fiches complètes avec des photos claires, des tailles précises et des descriptions honnêtes. Comparez avant d'acheter." },
      { q: "Quels sont les signes d'un mauvais vendeur ?", a: "Fiches vagues, prix irréalistes, photos de stock uniquement et vendeurs qui évitent de répondre." },
      { q: "Le vendeur le moins cher est-il toujours le meilleur ?", a: "Non. Un prix légèrement supérieur chez un vendeur plus détaillé mène souvent à un meilleur achat." },
    ],
    lastUpdated: "2026-08-19",
    author: "Équipe éditoriale Basetao Spreadsheet",
  },
};